import { useMemo, useState, useEffect } from 'react'
import { useTypedSelector } from '../../../../State/RootReducer'
import { CustomLayout } from '../../../chart-kit/shared/utils/chartModel'
import { Layouts } from 'react-grid-layout'
import usePresetChartLayout from './usePresetChartLayout'
import { ChartSettings, DEFAULT_CHART_HEIGHT } from 'src/Libs/chart-kit'
import useDefaultCharts from '../../default-charts/hooks/useDefaultCharts'
import { UserSettings } from 'src/Libs/user/types'

/**
 * Provides Default and Custom charts. They may be edited by the user.
 */
const useDefaultAndCustomCharts = (userSettings?: UserSettings): { defaultAndCustomCharts: CustomLayout[]; layouts: Layouts } => {
  const activeInstallation = useTypedSelector(state => state.storage.activeInstallation)
  const [editedCharts, setEditedCharts] = useState<CustomLayout[]>([])
  const presetLayout = usePresetChartLayout(editedCharts)
  const defaultCharts = useDefaultCharts()

  const chartSettingsList: ChartSettings[] =
    userSettings?.chartConfig?.map(config => {
      try {
        const parsed = JSON.parse(config)
        return parsed
      } catch (err) {
        console.log(err)
        return {}
      }
    }) ?? []

  const chartLayoutArray: Record<string, Layouts>[] =
    userSettings?.chartLayout?.map(config => {
      try {
        const parsed = JSON.parse(config)
        return parsed
      } catch (err) {
        console.log(err)
        return {}
      }
    }) ?? []

  useEffect(() => {
    setEditedCharts(
      chartSettingsList.map(setting => ({
        ...setting,
        isInitial: false,
        title: setting.name,
        views: setting.views ?? { hour: 'bar', day: 'line', month: 'bar', week: 'line', year: 'bar' },
        maxHeight: DEFAULT_CHART_HEIGHT,
        installationId: setting.installationId,
        storageSerialNumber: setting.storageSerialNumber,
      }))
    )
  }, [userSettings]) //eslint-disable-line

  return useMemo(() => {
    const layoutSetting = chartLayoutArray?.[0] ?? {}
    const hasLayoutForAll = !!layoutSetting['all']

    let layouts: Layouts

    if (hasLayoutForAll) {
      layouts = layoutSetting['all']
    } else if (activeInstallation && layoutSetting[activeInstallation]) {
      layouts = layoutSetting[activeInstallation]
    } else {
      layouts = presetLayout
    }

    return { defaultAndCustomCharts: [...defaultCharts, ...editedCharts], layouts: layouts }
  }, [defaultCharts, editedCharts]) //eslint-disable-line
}

export default useDefaultAndCustomCharts
